import React, { ReactNode, createContext, useContext, useState } from "react"

import { LocalStorage } from "wealthmode-frontend/util"

import { ColorMode, initialColorMode } from "@/lib/colorMode"

const STORAGE_KEY = "dashboard-color-mode"

interface ColorModeContextType {
  colorMode: ColorMode
  setColorMode: (mode: ColorMode) => void
}

const ColorModeContext = createContext<ColorModeContextType | undefined>(undefined)

/** Holds the colour mode chosen for the dashboard, remembered across visits. */
export function ColorModeProvider({ children }: { children: ReactNode }) {
  const [colorMode, setState] = useState<ColorMode>(() =>
    initialColorMode(new URLSearchParams(window.location.search).get("theme"), LocalStorage.get(STORAGE_KEY)),
  )

  const setColorMode = (mode: ColorMode) => {
    setState(mode)
    LocalStorage.set(STORAGE_KEY, mode)
  }

  return <ColorModeContext.Provider value={{ colorMode, setColorMode }}>{children}</ColorModeContext.Provider>
}

export function useColorMode() {
  const context = useContext(ColorModeContext)
  if (context === undefined) {
    throw new Error("useColorMode must be used within a ColorModeProvider")
  }
  return context
}
